import React, { useMemo } from "react";
import JoditEditor from "jodit-react";

interface RichTextEditorProps {
  value: string;
  onChange: (value: string) => void;
  height?: number;
  readonly?: boolean;
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onChange,
  height = 400,
  readonly = false,
}) => {
  const config = useMemo(
    () => ({
      readonly,
      height,
      placeholder: "Start typing...",
      toolbarAdaptive: false,
      toolbarSticky: false,
      askBeforePasteHTML: false,
      askBeforePasteFromWord: false,


      buttons: [
        "source",
        "|",
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "|",
        "font",
        "fontsize",
        "brush",
        "paragraph",
        "|",
        "ul",
        "ol",
        "|",
        "outdent",
        "indent",
        "|",
        "align",
        "|",
        "link",
        // "image",
        "table",
        // "video",
        "|",
        "hr",
        "eraser",
        "copyformat",
        "|",
        "undo",
        "redo",
        "|",
        "find",
        "fullsize",
        "preview",
        "print",
      ],
    }),
    [height, readonly]
  );

  return (
    <JoditEditor
      value={value}
      config={config}
      onBlur={(newContent) => onChange(newContent)}
    />
  );
};

export default RichTextEditor;